import './Design-System/app.css'
import './Design-System/main.css'
import MainPage from "./Pages/MainPage";
import { useEffect , useState } from 'react';
import BounceLoader
from "react-spinners/BounceLoader";

function App() {
  

  const [loading,setLoading] = useState(false)
  useEffect(() => {
    setLoading(true)
    setTimeout(()=> {
      setLoading(false)
    },2000)
  },[])

  return (
    <>
      {
        loading?
        <BounceLoader
        className='loader-spin'
        color={'#CC6C06'}
        loading={loading}
        size={150}
        speedMultiplier= {2}

      />
      :
        <MainPage  />
      }
    </>
    
  );
}

export default App;
